module.exports = __webpack_public_path__ + "static/img/eec-group2-2.5be7e71b.png";